import m from "../../../../geodata/es2015/region/usa/mnLow";
window.am4geodata_region_usa_mnLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/mnLow.js
// module id = null
// module chunks = 